/**
 * @generated SignedSource<<b5bc0af42ccf36e42b7b988cdc2e787d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RetroPGFListPageRouteQuery$variables = {
  id: string;
};
export type RetroPGFListPageRouteQuery$data = {
  readonly retroPGF: {
    readonly list: {
      readonly listContent: ReadonlyArray<{
        readonly OPAmount: number;
        readonly project: {
          readonly id: string;
        };
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"RetroPGFListContentPageFragment" | "RetroPGFListPageHeaderFragment">;
    } | null;
  };
};
export type RetroPGFListPageRouteQuery = {
  response: RetroPGFListPageRouteQuery$data;
  variables: RetroPGFListPageRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "OPAmount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RetroPGFListPageRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RetroPGF",
        "kind": "LinkedField",
        "name": "retroPGF",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "List",
            "kind": "LinkedField",
            "name": "list",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ListContent",
                "kind": "LinkedField",
                "name": "listContent",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RetroPGFListContentPageFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RetroPGFListPageHeaderFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RetroPGFListPageRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RetroPGF",
        "kind": "LinkedField",
        "name": "retroPGF",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "List",
            "kind": "LinkedField",
            "name": "list",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ListContent",
                "kind": "LinkedField",
                "name": "listContent",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bio",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OptimistProfile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "profileImageUrl",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "listDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "impactEvaluationDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "impactEvaluationLink",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ResolvedName",
                    "kind": "LinkedField",
                    "name": "resolvedName",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "listName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9b70e68d6840d71ba8ed19ec9006af40",
    "id": null,
    "metadata": {},
    "name": "RetroPGFListPageRouteQuery",
    "operationKind": "query",
    "text": "query RetroPGFListPageRouteQuery(\n  $id: ID!\n) {\n  retroPGF {\n    list(id: $id) {\n      listContent {\n        project {\n          id\n        }\n        OPAmount\n      }\n      ...RetroPGFListContentPageFragment\n      ...RetroPGFListPageHeaderFragment\n      id\n    }\n  }\n}\n\nfragment ENSAvatarFragment on ResolvedName {\n  name\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment RetroPGFAddListToBallotModalContentFragment on List {\n  id\n  listName\n  listContent {\n    project {\n      id\n      ...RetroPGFModalApplicationRowFragment\n    }\n    OPAmount\n  }\n}\n\nfragment RetroPGFListApplicationRowFragment on ListContent {\n  project {\n    id\n    displayName\n    bio\n    profile {\n      profileImageUrl\n      id\n    }\n  }\n  OPAmount\n}\n\nfragment RetroPGFListContentPageFragment on List {\n  listDescription\n  impactEvaluationDescription\n  impactEvaluationLink\n  listContent {\n    ...RetroPGFListApplicationRowFragment\n    OPAmount\n  }\n}\n\nfragment RetroPGFListPageHeaderFragment on List {\n  id\n  author {\n    resolvedName {\n      ...NounResolvedNameFragment\n      ...ENSAvatarFragment\n    }\n  }\n  listName\n  ...RetroPGFAddListToBallotModalContentFragment\n}\n\nfragment RetroPGFModalApplicationRowFragment on Project {\n  displayName\n  bio\n  profile {\n    profileImageUrl\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "010cf0fc0eb3dd1214b403f3220e0ced";

export default node;
